var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-2"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"height":"100","width":"100","alt":"No image found for this event"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }